import {useIntl} from 'react-intl'

const AmoCRMLineHeader = () => {
  const intl = useIntl()

  return (
    <thead>
      <tr className='fs-9 text-center'>
        <th role='columnheader' className='min-w-150px'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.LINE'})}
        </th>
        <th role='columnheader' className='min-w-140px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.DESCRIPTION'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.PIPELINE'})}
        </th>
        <th role='columnheader' className='min-w-150px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.USER'})}
        </th>
        <th role='columnheader' className='min-w-85px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.SMARTCALL'})}
        </th>
        <th role='columnheader' className='min-w-150px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.SMARTCALLBYTIME'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0 required'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.MODE'})}
        </th>
        <th role='columnheader' className='min-w-150px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.EDIT'})}
        </th>
      </tr>
    </thead>
  )
}

export {AmoCRMLineHeader}
